/* eslint-disable no-console */
import { Box, Button, Flex, Spacer } from '@chakra-ui/react';
import React, { useEffect, useMemo } from 'react';

import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import { useStatus } from '../hooks/bbplStatusContext';
import { BBPLMonitorParams } from '../types/bbplMonitorTypes';
import { MonitorModeControls } from './MonitorModeControls';
import { colors } from 'packages/common-frontend/colors';

// @bbplMonitor: remove this when its out of beta.
const BetaBadge = () => (
  <Box
    borderRadius="8px"
    backgroundColor={colors.aurora[50]}
    fontSize="12px"
    p="4px 8px"
    color={colors.black[70]}
  >
    Beta
  </Box>
);

// selection of options for BBPL Monitor
// this will let user select the reporting date and file version
// it populates the options in BBPLMonitorParams and calls onChange
// @bbplMonitor: add creditFacility selector here, when
// working in lender mode.
type BBPLMonitorOptionsProps = {
  initialParams: BBPLMonitorParams | null;
  onChange: (params: BBPLMonitorParams | null) => void;
};
export const BBPLMonitorOptions = ({
  initialParams,
  onChange,
}: BBPLMonitorOptionsProps) => {
  const { status } = useStatus();
  const defaultDateStr = commonDate.currentDateStr();

  const selected = useMemo(
    () => ({
      reportingDate:
        initialParams?.reportingDate ||
        status.mostRecentRDFV?.reportingDate ||
        defaultDateStr,
      fileVersion:
        initialParams?.fileVersion || status.mostRecentRDFV?.fileVersion || 1,
    }),
    [defaultDateStr, initialParams, status.mostRecentRDFV],
  );

  useEffect(() => {
    if (status.mostRecentRDFV && !initialParams) {
      onChange({
        ...selected,
        ...status.mostRecentRDFV,
      });
    }
  }, [initialParams, onChange, selected, status.mostRecentRDFV]);

  // when user selection changes call onChagne.
  // we do that only when latestArtifactDocumentId is known
  // latestArtifactDocumentId is known only after initial status query is finished.
  return (
    <Box width="100%" mb="5px">
      <Flex minWidth="max-content" alignItems="center" gap="2">
        <MonitorModeControls
          onMonitor={(
            newReportingDate: Util.FullDateStr,
            newFileVersion: number,
          ) => {
            const updated = {
              ...selected,
              reportingDate: newReportingDate,
              fileVersion: newFileVersion,
            };
            onChange(updated);
          }}
          reportingDate={selected.reportingDate}
          fileVersion={selected.fileVersion}
        />

        {status.mostRecentRDFV && (
          <Button
            disabled={
              selected.reportingDate === status.mostRecentRDFV.reportingDate &&
              selected.fileVersion === status.mostRecentRDFV.fileVersion
            }
            onClick={() => {
              onChange({
                ...selected,
                ...status.mostRecentRDFV,
              });
            }}
            ml="5px"
          >
            Go to Latest
          </Button>
        )}
        <Spacer />
        <BetaBadge />
      </Flex>
    </Box>
  );
};
